import dynamic from 'next/dynamic';
import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Text from 'shopper/components/Text';

import { toLastCommentsLink } from 'lib/links';

import TOPBAR from 'constants/topbar';

const Tag = dynamic(() => import('shopper/components/Tag'), {
  ssr: false,
});

const CommentsButton = ({ commentsCount, ...rest }) => (
  <NextLink href={toLastCommentsLink()} prefetch={false} passHref>
    <Button
      as="a"
      type="ghost"
      size="size2"
      data-test-selector="comments-tab"
      {...rest}
    >
      <Text>{TOPBAR.BUTTON_COMMENTS}</Text>
      {commentsCount > 0 && (
        <Tag size="size4" ml={2}>
          {commentsCount}
        </Tag>
      )}
    </Button>
  </NextLink>
);

CommentsButton.defaultProps = {
  commentsCount: 0,
};

CommentsButton.propTypes = {
  commentsCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CommentsButton;
